import { render, staticRenderFns } from "./QuickDeclareStep2.vue?vue&type=template&id=7a4b828d&scoped=true&"
import script from "./QuickDeclareStep2.vue?vue&type=script&lang=js&"
export * from "./QuickDeclareStep2.vue?vue&type=script&lang=js&"
import style0 from "./QuickDeclareStep2.vue?vue&type=style&index=0&id=7a4b828d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4b828d",
  null
  
)

export default component.exports